import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth-context";
import { ProductProvider } from "@/lib/product-context";
import ProtectedRoute from "@/components/ProtectedRoute";
import ProductGate from "@/components/ProductGate";
import Layout from "@/components/Layout";
import KlysticHubPage from "@/pages/KlysticHubPage";
import DashboardPage from "@/pages/DashboardPage";
import NewSessionPage from "@/pages/NewSessionPage";
import RunnerPage from "@/pages/RunnerPage";
import SummaryPage from "@/pages/SummaryPage";
import SessionDetailPage from "@/pages/SessionDetailPage";
import ConsolidatedPage from "@/pages/ConsolidatedPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import Reset2FAPage from "@/pages/Reset2FAPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ProductProvider>
            <Routes>
              {/* Public auth screens */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/reset-2fa" element={<Reset2FAPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />

              {/* Klystic hub — protected but no product needed */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <KlysticHubPage />
                  </ProtectedRoute>
                }
              />

              {/* Product-scoped app */}
              <Route
                element={
                  <ProtectedRoute>
                    <ProductGate>
                      <Layout />
                    </ProductGate>
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/consolidated" element={<ConsolidatedPage />} />
                <Route path="/admin/users" element={<AdminUsersPage />} />
                <Route path="/new" element={<NewSessionPage />} />
                <Route path="/session/:id/run" element={<RunnerPage />} />
                <Route path="/session/:id/summary" element={<SummaryPage />} />
                <Route path="/session/:id" element={<SessionDetailPage />} />
              </Route>
            </Routes>
          </ProductProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
